// Unpublished Work © 2020-2025 Deere & Company.

import t from 'tcomb';
import {PageStatus} from '../page-status';
import {SaveError} from './save-error';
import {addressKeys} from '../customer/communication';

export const ApplicationStatus = t.struct({
    addressCountryCode: t.String,
    cityDropdownStatus: t.struct({
        [addressKeys.MAILING_ADDRESS]: t.String,
        [addressKeys.PHYSICAL_ADDRESS]: t.String
    }),
    canResetForm: t.Boolean,
    canShowCountryServiceError: t.Boolean,
    canFillCustomerDetailsFromFacets: t.Boolean,
    deceasedOutOfBusinessFlowIndicator: t.Boolean,
    isDeceasedOrOutOfBusinessModalShown: t.Boolean,
    isEditCustomerSaveButtonEnabled: t.Boolean,
    isPotentialMatchesModalShown: t.Boolean,
    customerProfileStatus: PageStatus,
    fullPageLoadingStatus: PageStatus,
    pageStatus: PageStatus,
    preferredLanguageStatus: PageStatus,
    saveCustomerStatus: PageStatus,
    saveError: SaveError,
    showConfirmationModal: t.Boolean,
    showReasonCaptureForm: t.Boolean,
    specificCountryStatesStatus: PageStatus
}, {
    defaultProps: {
        addressCountryCode: '',
        cityDropdownStatus: {
            [addressKeys.MAILING_ADDRESS]: PageStatus.meta.map.COMPLETE,
            [addressKeys.PHYSICAL_ADDRESS]: PageStatus.meta.map.COMPLETE
        },
        canResetForm: false,
        canShowCountryServiceError: false,
        canFillCustomerDetailsFromFacets: false,
        deceasedOutOfBusinessFlowIndicator: false,
        isDeceasedOrOutOfBusinessModalShown: false,
        isPotentialMatchesModalShown: false,
        isEditCustomerSaveButtonEnabled: false,
        fullPageLoadingStatus: PageStatus.meta.map.COMPLETE,
        pageStatus: PageStatus.meta.map.LOADING,
        preferredLanguageStatus: PageStatus.meta.map.COMPLETE,
        customerProfileStatus: PageStatus.meta.map.COMPLETE,
        saveCustomerStatus: PageStatus.meta.map.COMPLETE,
        saveError: SaveError({}),
        showConfirmationModal: false,
        showReasonCaptureForm: false,
        specificCountryStatesStatus: PageStatus.meta.map.COMPLETE
    },
    name: 'ApplicationStatus',
    strict: true
});
